module.exports = __webpack_public_path__ + "img/frame (237).4a9b4966.jpg";